import React, { forwardRef } from 'react';

import { MultipleSelectProduct } from './multiple';
import { SingleSelectProduct } from './single';

type SingleSelectProductValueProps = {
  single?: true;
  selected?: number;
};

type MultipleSelectProductValueProps = {
  single?: false;
  selected?: number[];
};

type IProps = {
  endpoint?: string;
  disabled?: boolean;
  inputClearButton?: boolean;
  label?: React.ReactNode;
} & (SingleSelectProductValueProps | MultipleSelectProductValueProps);

export interface ISelectProductMultipleHandles {
  unCheckAll: () => void;
}

const SelectProductComponent: React.ForwardRefRenderFunction<ISelectProductMultipleHandles, IProps> = (
  { label, endpoint, inputClearButton, disabled, ...props },
  ref
) => {
  const defaultProps = { label, endpoint, disabled };

  if (props.single === true) return <SingleSelectProduct {...defaultProps} inputClearButton={inputClearButton} />;

  return <MultipleSelectProduct ref={ref} selected={props.selected} {...defaultProps} />;
};

export const SelectProduct = forwardRef(SelectProductComponent);
